module.exports = __webpack_public_path__ + "static/media/bg4.f48d9b75.png";